// extracted by mini-css-extract-plugin
module.exports = {"warp":"Home_warp__1Aiaw","container":"Home_container__2BZ5-","beEmbeddedWrap":"Home_beEmbeddedWrap__McFBb"};